import { render, staticRenderFns } from "./StampExchangeConfirm.vue?vue&type=template&id=765124b8&scoped=true&"
import script from "./StampExchangeConfirm.vue?vue&type=script&lang=js&"
export * from "./StampExchangeConfirm.vue?vue&type=script&lang=js&"
import style0 from "./StampExchangeConfirm.vue?vue&type=style&index=0&id=765124b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765124b8",
  null
  
)

export default component.exports